<template>
  <Loader v-if="loading" />

  <!-- Hydrated -->

  <AppLayout v-else>
    <main class="vp-overflow-auto">
      <div class="vp-flex vp-h-full vp-flex-col">
        <EmailNotVerified />
        <AccountDowngraded />
        <!-- Header -->
        <div
          class="vp-h-12 vp-flex vp-items-stretch vp-border-b vp-relative vp-z-20"
        >
          <Breadcrumbs class="vp-flex-grow" />
          <div class="vp-ml-auto vp-flex vp-items-center vp-px-2">
            <PortalTarget name="header" slim />
          </div>
        </div>
        <!-- Content -->

        <!-- Handle Scroll issue -->
        <div class="vp-flex-grow vp-overflow-auto">
          <RouterView></RouterView>
        </div>
      </div>
      <FrillWidget />
    </main>
  </AppLayout>
</template>

<script>
import { version } from "../../../package.json";
import EmailNotVerified from "components/src/email/not-verified.vue";
import hydrate from "./get.gql";
import { getCampaign, setCampaign } from "plugins/utils.js";
import FrillWidget from "components/src/frill-widget.vue";

import AccountDowngraded from "components/src/account/downgraded.vue";
import Breadcrumbs from "components/src/app/breadcrumbs.vue";
import { mapActions, mapGetters } from "vuex";
import Loader from "components/src/app/loader.vue";
// import { toWeb } from "plugins/utils.js";
import AppLayout from "@/components/app-layout.vue";

export default {
  version,

  components: {
    FrillWidget,
    EmailNotVerified,
    AccountDowngraded,
    Breadcrumbs,
    Loader,
    AppLayout,
  },
  computed: {
    ...mapGetters({
      bizUrl: "biz/url",
    }),
  },
  mounted() {
    this.$root.$on("rehydrate", (campaignId, web, serviceWorker) => {
      if (campaignId) {
        setCampaign(campaignId);
      }
      this.rehydrate(web, serviceWorker);
    });
  },
  created() {
    this.startHydration();
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      hydrate: "hydrate",
    }),
    rehydrate(web, serviceWorker = true) {
      /**
       * Need to register prototypes in side created hook to have access to component instance.
       * We're connecting with the Chrome Extension
       * When any change is done in admin panel which needs to be updated in extension too,
       * we sent a rehydrate request to extension service worker script.
       *
       * https://developer.chrome.com/docs/extensions/mv2/messaging/
       */

      //Rehydrate web platform only if required
      if (web) {
        this.$cache.evict({
          id: "ROOT_QUERY",
        });
        this.startHydration(serviceWorker);
      }
    },
    startHydration(serviceWorker) {
      if (!serviceWorker) {
        this.loading = true;
      }
      this.loading = true;

      this.hydrate({
        request: this.$query(
          hydrate,
          {
            campaignId: getCampaign(),
            userId: null,
          },
          {
            // Cache refresh is required here for biz setup create account flow, redirection back to this route
            noCache: true,
          }
        ),
        version,
      })
        .then((res) => {
          console.log({ res });
          if (!res.campaign.vepaarProducts?.cards.cards.length) {
            this.$router.push({ name: "welcome" });
          }
        })
        .catch((err) => {
          console.error(err);
          // toWeb("logout");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
